export type NoticeDraft={scope:string;details:string;evidence:string;confirmed:boolean;sourceKey:string;channel:'email'|'sms';language:'en'|'zh'};
export const noticeDraftPrefix='aiw-installation-notice-draft:v1:';
export function noticeDraftKey(api:string,user:string,job:string,testSet:string|null){return noticeDraftPrefix+JSON.stringify([api,user,job,testSet]);}
export function readNoticeDraft(storage:Pick<Storage,'getItem'>,key:string):NoticeDraft|null{
 try{
  const d=JSON.parse(storage.getItem(key)??'null') as NoticeDraft|null;
  return d&&['scope','details','evidence','sourceKey'].every(k=>typeof d[k as keyof NoticeDraft]==='string')&&typeof d.confirmed==='boolean'&&['email','sms'].includes(d.channel)&&['en','zh'].includes(d.language)?d:null;
 }catch{return null;}
}
export function writeNoticeDraft(storage:Pick<Storage,'setItem'>,key:string,draft:NoticeDraft){
 try{storage.setItem(key,JSON.stringify(draft));return true;}catch{return false;}
}
export function clearNoticeDrafts(storage:Storage){
 for(let i=storage.length-1;i>=0;i--){const key=storage.key(i);if(key?.startsWith(noticeDraftPrefix))storage.removeItem(key);}
}
/** A delayed save response must not remove wording typed after navigation. */
export function clearMatchingNoticeDraft(storage:Storage,key:string,submitted:NoticeDraft){
 try{if(JSON.stringify(readNoticeDraft(storage,key))!==JSON.stringify(submitted))return false;storage.removeItem(key);return true;}catch{return false;}
}
